import { createSlice } from "@reduxjs/toolkit";
import { FeesDetailsThunk } from "./services/thunk/DetailsThunk";

const initialState = {
  feesDetails: null,
  loading: false,
  error: null
};

const feesDetailsSlice = createSlice({
  name: "feesDetails",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(FeesDetailsThunk.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FeesDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.feesDetails = action.payload; // This will be {provisionalFees, BankGuarantee, totalProvisionalFees}
      })
      .addCase(FeesDetailsThunk.rejected, (state, action) => {
        state.loading = false;
      });
  }
});

export default feesDetailsSlice.reducer;
